<section
  class="container"
  [ngClass]="{accessible: accessibilityMode}"
  role="dialog"
  id="{{UPLOAD_DIALOG_ID}}"
  aria-modal="true"
  tabindex="-1"
  [attr.aria-labelledby]="'upload-guide-title'"
  [attr.aria-describedby]="'upload-guide-description'">
  <div class="section">
    <app-vi-action-button [type]="ActionButtonType.ACTION_BUTTON"
      [action]="backAction"
      [width]="'auto'"
      (actionClick)="backBtnClicked()"
      id="back">
    </app-vi-action-button>
    <h2 class="title"
      id="upload-guide-title"
      tabindex="-1">{{resources?.UploadGuidelinesTitle}}</h2>
    <section role="region"
      aria-labelledby="section1-heading">
      <h3 class="sub-title"
        id="section1-heading"
        role="heading"
        aria-level="3"
        tabindex="0">{{resources?.UploadGuidelinesSubTitle1}}</h3>
      <ul class="list"
        role="list"
        aria-labelledby="section1-heading"
        aria-describedby="section1-description">
        <li role="listitem"
          tabindex="0">
          <span class="bullet"></span>
          <span class="text">{{resources?.UploadGuidelinesSection1List1}}</span>
        </li>
        <li role="listitem"
          tabindex="0">
          <span class="bullet"></span>
          <span class="text">{{resources?.UploadGuidelinesSection1List2}}</span>
        </li>
        <li role="listitem"
          tabindex="0">
          <span class="bullet"></span>
          <span class="text">{{resources?.UploadGuidelinesMaxFilesLimit}}</span>
        </li>
      </ul>
      <a role="link"
        (appAccessibleClick)="openLink(formatsLink)"
        [title]="resources?.UploadGuidelinesLink1"
        [attr.aria-label]="resources?.UploadGuidelinesLink1"
        target="_blank"
        rel="noopener noreferrer"
        tabindex="0">{{resources?.UploadGuidelinesLink1}}</a>
    </section>
  </div>
  <div class="section">
    <section role="region"
      aria-labelledby="section2-heading">
      <h3 class="sub-title"
        id="section2-heading"
        role="heading"
        aria-level="3"
        tabindex="0">{{resources?.UploadGuidelinesSubTitle2}}</h3>
      <ul class="list"
        role="list"
        aria-labelledby="section2-heading">
        <li role="listitem"
          tabindex="0">
          <span class="bullet"></span>
          <span class="text"
            [innerHtml]="resources?.UploadGuidelinesSection2List1"></span>
        </li>
        <li role="listitem"
          tabindex="0">
          <span class="bullet"></span>
          <span class="text">{{resources?.UploadGuidelinesSection2List2}}</span>
        </li>
        <li role="listitem"
          tabindex="0">
          <span class="bullet"></span>
          <span class="text">{{resources?.UploadGuidelinesMaxFilesLimit}}</span>
        </li>
      </ul>
      <a role="link"
        (appAccessibleClick)="openLink(limitationsLink)"
        [title]="resources?.UploadGuidelinesLink2"
        [attr.aria-label]="resources?.UploadGuidelinesLink2"
        target="_blank"
        rel="noopener noreferrer"
        tabindex="0">{{resources?.UploadGuidelinesLink2}}</a>
    </section>
  </div>
</section>
